import { Clipboard } from '@angular/cdk/clipboard';
import { ChangeDetectorRef } from '@angular/core';
import { DELEGATOR_ENCRYPT_MSG } from '@helpers/crypt';
import { DestroyService } from '@services/destroy.service';
import { ProviderService } from '@services/provider.service';
import * as CryptoJS from 'crypto-js';
import { ethers } from 'ethers';
import { NGXLogger } from 'ngx-logger';
import { catchError, finalize, from, mergeMap, Observable, takeUntil } from 'rxjs';

export function useDelegationFromSign(
  account: string,
  delegator: string,
  encryptedDelegatePrivateKey: string,
  destroy$: DestroyService,
  providerService: ProviderService,
  changeDetectorRef: ChangeDetectorRef,
  logger: NGXLogger,
  errorCallBack: (msg: string) => void,
  finalizeCallBack: () => void,
) {
  // this.errorMsg = '';
  //
  // if (!this.encryptedDelegatePrivateKey) {
  //   this.errorMsg = 'No encrypted PK!';
  //
  //   return;
  // }
  //
  // this.processing = true;

  providerService
    .getSignerForWrite$(account, false)
    .pipe(takeUntil(destroy$))
    .subscribe(signer => {
      from(signer.signMessage(DELEGATOR_ENCRYPT_MSG))
        .pipe(
          catchError(err => {
            errorCallBack('Message signing error');
            changeDetectorRef.detectChanges();
            return err;
          }),
          finalize(() => {
            finalizeCallBack();
          }),
          takeUntil(destroy$),
        )
        .subscribe(signedMessage => {
          const pk = CryptoJS.AES.decrypt(encryptedDelegatePrivateKey, signedMessage).toString(CryptoJS.enc.Utf8);

          if (new ethers.Wallet(pk).address.toLowerCase() !== delegator.toLowerCase()) {
            logger.error('Private key for not delegator', new ethers.Wallet(pk).address, delegator);
            errorCallBack('Private key for not delegator');
            changeDetectorRef.detectChanges();
            return;
          }
          providerService.setupPrivateKeyDelegated(pk);
          changeDetectorRef.detectChanges();
        });
    });
}

export function createWallet(
  chainId: number,
  destroy$: DestroyService,
  providerService: ProviderService,
  logger: NGXLogger,
  passwordGetter: () => Observable<string>,
  storageCallBack: (chainId: number, pkEncrypted: string, walletAddress: string) => Observable<any>,
  finalizeCallBack: () => void,
  successCallback: () => void,
) {
  const wallet = ethers.Wallet.createRandom();
  logger.trace('Create new wallet', wallet.address);

  passwordGetter()
    .pipe(
      mergeMap(password => {
        const pkEncrypted = CryptoJS.AES.encrypt(wallet.privateKey, password).toString();
        return storageCallBack(chainId, pkEncrypted, wallet.address);
      }),
      finalize(() => {
        finalizeCallBack();
      }),
      takeUntil(destroy$),
    )
    .subscribe(() => {
      providerService.setupPrivateKeyDelegated(wallet.privateKey);
      successCallback();
    });
}

export function simpleCreateWallet() {
  return ethers.Wallet.createRandom();
}

export function encodePrivateKey(privateKey: string, password: string) {
  return CryptoJS.AES.encrypt(privateKey, password).toString();
}

export function decodePrivateKey(encryptedPrivateKey: string, password: string) {
  return CryptoJS.AES.decrypt(encryptedPrivateKey, password).toString(CryptoJS.enc.Utf8);
}
